// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3C8hI","imageUploader":"EGiftCard_imageUploader__1gcez"};